var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"46","height":"46","fill":"none"}},[_c('circle',{attrs:{"cx":"23","cy":"23","r":"22.5","fill":"currentColor","stroke":"#EBEBEB"}})])
}
var staticRenderFns = []

export default { render: render }